import React, { useMemo } from "react";
import { Banner } from "@bookingcom/bui-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline";
import { useSelector } from "react-redux";
import { useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import Frame from "../../Frame/index.js";
import useGetSearchResultsBound from "../../../../hooks/useGetSearchResultsBound.js";
import { getSearchDisplayOptions } from "../../../../store/searchResults/selectors.js";
import { getSearchDisplayOptions as getOBSearchDisplayOptions } from "../../../../store/searchResultsBounds/outboundSelectors.js";
import { getSearchDisplayOptions as getIBSearchDisplayOptions } from "../../../../store/searchResultsBounds/inboundSelectors.js";
const NoDirectFlightsBanner = ({ show } = {}) => {
    const i18n = useI18n();
    const bound = useGetSearchResultsBound();
    const getDisplayOptions = useMemo(() => {
        switch (bound) {
            case "outbound":
                return getOBSearchDisplayOptions;
            case "inbound":
                return getIBSearchDisplayOptions;
            default:
                return getSearchDisplayOptions;
        }
    }, [bound]);
    const displayOptions = useSelector(getDisplayOptions);
    const shouldShow = show !== undefined ? show : displayOptions?.directFlightsOnlyFilterIgnored;
    if (!shouldShow)
        return null;
    return (React.createElement(Frame, { mb: 4 },
        React.createElement(Banner, { dismissible: false, variant: "callout", startIcon: InfoSignIcon, attributes: { "data-testid": "no_direct_flights_banner" } }, i18n.trans(t("flights_search_results_no_direct_flights_options_banner")))));
};
export default NoDirectFlightsBanner;
